// const primaryColor = '#004990';
// const secondaryColor = '#00A8FF';
// const dangerColor = '#D9322D';
// const successColor = '#70A527';
// const warningColor = '#FFBC00';
// const defaultColor = '#93989E';

// const defaultDark70 = '#2C2D2F';

// const primaryLight10 = '#1A5C9B';

// const primaryDark20 = '#003a73';
// const primaryDark30 = '#003366';
// const primaryDark40 = '#002c57';

const theme = {
  // defaultTextColor: defaultDark70,

  // containerPadding: '20px',
  // primaryBlue10: '#0072BC',
  // primaryBlue20: '#00599A',
  // bgGray: '#F5F5F5',
  // authBgColor: '#004990',

  // primaryColor: primaryColor,
  // secondaryColor: secondaryColor,
  // dangerColor: dangerColor,
  // successColor: successColor,
  // warningColor: warningColor,
  // defaultColor: defaultColor,
  color: {
    neutral11: '#2C2D2F',
  },
  responsiveXsMax: '767px',
  responsiveSmMin: '768px',
  responsiveSmMax: '991px',
  responsiveMdMin: '992px',
  responsiveMdMax: '1199px',
  responsiveLgMin: '1200px',
  // Header
  // header: {
  // bgColor: primaryColor,
  // height: '60px',
  // menuColor: '#fff',
  // menuFontSize: '16px',
  // menuFontWeight: '400',
  // menuActiveFontWeight: '500',
  // asterixColor: primaryDark40,
  // profile: {
  //   background: primaryDark20,
  //   actionBg: primaryDark30,
  //   menuColor: '#fff',
  //   menuFontSize: '16px',
  //   menuFontWeight: '400',
  // },
  // popUpMenu: {
  //   overlayBgColor: primaryDark40,
  //   overlayShadeColor: 'rgba(0, 0, 0, 0.4)',
  //   thumbnailItemFontSize: '18px',
  //   thumbnailFontWeight: '400',
  //   thumbnailColor: 'white',
  //   thumbnailBoxBg: primaryColor,
  //   thumbnailBoxButtonBg: primaryDark40,
  //   thumbnailBoxButtonColor: '#fff',
  //   thumbnailBoxButtonHoverBg: primaryDark30,
  //   thumbnailBoxButtonHoverColor: '#fff',
  //   listItemFontSize: '16px',
  //   listItemFontWeight: '400',
  //   listItemColor: 'white',
  //   listItemBgColor: primaryColor,
  //   listItemHoverBgColor: primaryLight10,
  // },

  //   mobile: {
  //     background: primaryDark30,
  //     toggleBg: primaryDark20,
  //     toggleHoverBg: primaryDark30,
  //     toggleProfileBg: primaryDark30,
  //     asterixColor: primaryDark30,
  //   },
  // },
  // sidebar: {
  //   background: primaryColor,
  //   buttonBgColor: primaryDark40,
  // },
  // Footer
  // footer: {
  //   bgColor: primaryColor,
  //   linkButtonBgColor: '#004281',

  //   height: '40px',
  // },
};

export default theme;
